'use client';

import _toConsumableArray from "/codebuild/output/src796/src/s3/01/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/codebuild/output/src796/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx } from 'react/jsx-runtime';
import { useUncontrolled } from '@mantine/hooks';
import 'react';
import 'clsx';
import '../../../core/MantineProvider/Mantine.context.mjs';
import '../../../core/MantineProvider/default-theme.mjs';
import '../../../core/MantineProvider/MantineProvider.mjs';
import '../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../../core/MantineProvider/use-props/use-props.mjs';
import '../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import '../../../core/Box/Box.mjs';
import '../../../core/DirectionProvider/DirectionProvider.mjs';
import { ChipGroupProvider } from '../ChipGroup.context.mjs';
var defaultProps = {};
function ChipGroup(props) {
  var _useProps = useProps("ChipGroup", defaultProps, props),
    value = _useProps.value,
    defaultValue = _useProps.defaultValue,
    onChange = _useProps.onChange,
    multiple = _useProps.multiple,
    children = _useProps.children;
  var _useUncontrolled = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: multiple ? [] : null,
      onChange: onChange
    }),
    _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
    _value = _useUncontrolled2[0],
    setValue = _useUncontrolled2[1];
  var isChipSelected = function isChipSelected(val) {
    return Array.isArray(_value) ? _value.includes(val) : val === _value;
  };
  var handleChange = function handleChange(event) {
    var val = event.currentTarget.value;
    if (Array.isArray(_value)) {
      setValue(_value.includes(val) ? _value.filter(function (v) {
        return v !== val;
      }) : [].concat(_toConsumableArray(_value), [val]));
    } else {
      setValue(val);
    }
  };
  return /* @__PURE__ */jsx(ChipGroupProvider, {
    value: {
      isChipSelected: isChipSelected,
      onChange: handleChange,
      multiple: multiple
    },
    children: children
  });
}
ChipGroup.displayName = "@mantine/core/ChipGroup";
export { ChipGroup };